import React from "react";
import { ScrollArea } from "@mantine/core";

function Navbar({ children }) {
    return (
        <ScrollArea pt={32} scrollbarSize={3}>
            {children}
        </ScrollArea>
    )
}

export {
    Navbar
}